import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

export async function fetchPublishedLibraryItems(appId) {
  const refCol = collection(db, 'artifacts', appId, 'public', 'data', 'library_items');
  const q = query(refCol, orderBy('updated_at', 'desc'), limit(150));
  const snap = await getDocs(q);
  const raw = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  return raw.filter((it) => {
    const s = String(it?.status || '').toUpperCase();
    return s === 'PUBLISHED';
  });
}
